import { connect } from 'react-redux';

import { getOrderByOrderId, resetPage } from '../../actions/ReceiptPage';
import ReceiptPage from './ReceiptPage';

const mapsStateToProps = state => ({
	receiptPageProps: state.receiptPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getOrderByOrderId(order_id, token) {
		dispatch(getOrderByOrderId(order_id, token));
	},
	resetPage() {
		dispatch(resetPage());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(ReceiptPage);
